import MOCK_DATA from '../mock/polls-groupclass.json';
import apiClient from '../helper/apiClient';
import { SERVICE_ROUTES, PARAM_KEY_AUTH_TOKEN } from '../constants/service.constants';
import MOCK_POLLS_RESULT_DATA from '../mock/pollsresult.json';
import { getFilenameFromContentDisposition } from '../helper/contentDispositionParser';
import LoggerService from './logger.service';
import { fetchAttendeeReportDownloadToken as fetchPollReportToken } from '../service/auth.service';
import ZoomAppClient from '../helper/zoomAppClient';
import { downloadFileResource } from '../helper/domHelper';
import { REPORT_DOWNLOAD_CLASS } from '../constants/dom.constants';
import { PARAM_KEY_MEETING_UUID } from '../constants/app.constants';

export const getPollsGroupClassData = async payload => {
  if (process.env.NODE_ENV !== 'development') {
    const httpClient = apiClient.getZoomAppBffInstance();
    return httpClient.post(SERVICE_ROUTES.FETCH_POLLS_GROUP_LIST, payload);
  }
  return MOCK_DATA;
};

export const getPollsResultData = zoomMeetingUUID => {
  if (process.env.NODE_ENV !== 'development') {
    const httpClient = apiClient.getZoomAppBffInstance();
    const serviceUrl = `${SERVICE_ROUTES.FETCH_POLLS_GROUP_LIST_RESULT}`;
    const endPoint = serviceUrl.replace('{zoomMeetingUUID}', encodeURIComponent(zoomMeetingUUID));
    const response = httpClient.get(endPoint);
    return response;
  }
  return MOCK_POLLS_RESULT_DATA;
};


export const getPollReportDownloadToken = async () => {
  const responseData = {
    success: null,
    error: null
  };

  try {
    const response = await fetchPollReportToken();
    responseData.success = response && response.access_token ? response.access_token : null;
  }
  catch (error) {
    LoggerService.log('reports.service', 'Error fetching poll report download token', { error });
    responseData.error = error;
  }
  return responseData;
};

export const fetchPollReportDetails = async ({ zoomMeetingUuid, authToken }) => {
  const httpClient = apiClient.getReportDownloadRawInstance();
  const endPoint = SERVICE_ROUTES.DOWNLOAD_POLL_REPORT.replace('{zoomMeetingUuid}', encodeURIComponent(zoomMeetingUuid));
  const responseData = {
    success: null,
    error: null
  };

  try {
    const response = await httpClient.get(endPoint, { headers: { Authorization: `Bearer ${authToken}` }, responseType: 'blob' });
    const data = response && response.data ? response.data : response;
    const headers = response && response.headers ? response.headers : {};
    const fileName = getFilenameFromContentDisposition(headers) || `poll-report-${zoomMeetingUuid}.xlsx`;
    responseData.success = { blobData: data, fileName };
  }
  catch (error) {
    LoggerService.log('reports.service', 'Error downloading poll report', { error, zoomMeetingUuid });
    responseData.error = error;
  }
  return responseData;
};

export const prepareExternalPollPageUrl = ({ authToken, zoomMeetingUuid, pollReportPagePath }) => {
  const params = new URLSearchParams({
    [PARAM_KEY_AUTH_TOKEN]: authToken,
    [PARAM_KEY_MEETING_UUID]: zoomMeetingUuid
  });

  const originAvailable = typeof location !== 'undefined' && location?.origin;
  const baseUrl = originAvailable ? location.origin.replace(/\/$/, '') : '';
  const normalizedPath = pollReportPagePath.replace(/^\/+/, '');

  if (baseUrl) {
    return `${baseUrl}/${normalizedPath}?${params.toString()}`;
  }

  // Fallback to relative path when location.origin isn't available
  return `/${normalizedPath}?${params.toString()}`;
};

export const initiateExternalPollDownload = async (externalUrl) => {
  const responseData = {
    success: null,
    error: null
  };
  try {
    await ZoomAppClient.openExternalUrl(externalUrl);
    responseData.success = 'External URL opened successfully';
  }
  catch (error) {
    LoggerService.log('reports.service', 'Failed to open external URL for poll report download', { error });
    responseData.error = error;
  }
  return responseData;
};

export const extractPollReportParamsFromUrl = (searchParams) => {
  const authToken = searchParams.has(PARAM_KEY_AUTH_TOKEN) ? searchParams.get(PARAM_KEY_AUTH_TOKEN) : null;
  const zoomMeetingUuid = searchParams.has(PARAM_KEY_MEETING_UUID) ? searchParams.get(PARAM_KEY_MEETING_UUID) : null;
  return { authToken, zoomMeetingUuid };
};

export const downloadPollReportFile = async ({ blobData, fileName }) => {
    if (!blobData) {
      LoggerService.log('reports.service', 'No blob data provided for poll report download', { fileName });
      return { error: 'No blob data' };
    }
    const fileUrl = globalThis.URL.createObjectURL(blobData);
    downloadFileResource(REPORT_DOWNLOAD_CLASS, fileUrl, fileName);
    // Defer revoking the object URL to ensure the download has been triggered.
    Promise.resolve().then(() => { try { globalThis.URL.revokeObjectURL(fileUrl); } catch(e){
      LoggerService.log('reports.service', 'Failed to revoke object URL for poll report', { error: e });
    } });
};
